var FeatureStorage = /** @class */ (function () {
    function FeatureStorage() {
    }
    FeatureStorage.isExpired = function () {
        var storage = JSON.parse(sessionStorage.getItem(FeatureStorage.StorageKey));
        return !storage || new Date().getTime() - new Date(storage.timestamp).getTime() > FeatureStorage.StorageCacheTime;
    };
    FeatureStorage.isFeatureEnabled = function (name) {
        var _a, _b;
        return (_b = (_a = this.getFeatures()) === null || _a === void 0 ? void 0 : _a[name]) !== null && _b !== void 0 ? _b : false;
    };
    FeatureStorage.getFeatures = function () {
        var storage = JSON.parse(sessionStorage.getItem(FeatureStorage.StorageKey));
        return storage === null || storage === void 0 ? void 0 : storage.features;
    };
    FeatureStorage.storeFeatures = function (features) {
        sessionStorage.setItem(FeatureStorage.StorageKey, JSON.stringify({
            timestamp: new Date(),
            features: features
        }));
    };
    FeatureStorage.StorageKey = "EmailEditor_FeatureService";
    FeatureStorage.StorageCacheTime = 2 * 60 * 1000;
    return FeatureStorage;
}());
export { FeatureStorage };
